import { Container } from "@mantine/core";
import { Suspense, useEffect, ViewTransition } from "react";
import { Outlet, useLocation } from "react-router-dom";
import styles from "./styles/Layout.module.css";
import { Footer } from "./Footer";
import { NavigationProgress } from "./layout/NavigationProgress";
import { clearArtworkMorph } from "@/hooks/useArtworkMorph";
import { RouteSkeleton } from "./layout/RouteSkeleton";

export const Layout = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        clearArtworkMorph();
    }, [pathname]);

    return (
        <>
            <NavigationProgress />
            <div className={"main " + styles.main}>
                <Container size="lg">
                    {/* Keyed by path so each page enters/exits as its own view transition */}
                    <ViewTransition key={pathname} enter="page-enter" exit="page-exit" default="none">
                        {/* Only the page waits here: the header, the progress bar and the footer stay on screen while it loads */}
                        <Suspense fallback={<RouteSkeleton />}>
                            <Outlet />
                        </Suspense>
                    </ViewTransition>
                </Container>
            </div>
            <Footer />
        </>
    );
};
